export default __webpack_public_path__ + "static/hero-linkedin-feed-7f891df4cef6c524f7a9f1cb017a6c54.png";